import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { Button, Paper } from '@mui/material';
import Select from 'react-select';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { FocusError } from 'focus-formik-error';
import { useDispatch, useSelector } from 'react-redux';
import { BeatLoader } from 'react-spinners';
// import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import { toast } from 'react-toastify';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import { adminMainUrl } from "../../../Config.jsx";
import { getCustomerProfileData } from '../../../Redux/action/Admin/CustomerAction.js';

const BankDetails = ({ loadingCustomerProfileDataApi, CustomerProfileDataError, CustomerProfileData, disbaledProfileEditing }) => {
  let [disable, setDisable] = useState(false);
  let [showLoader, setShowLoader] = useState(true);
  const dispatch = useDispatch();
  const token = Cookies.get('customertoken');


  let initialValues = {

    bankName: "",
    bankAddress: "",
    beneficiaryName: "",
    bankAccountNum: "",
    ifscCode: "",


  }

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object({
      bankName: Yup.string().required("Please enter bank name."),
      bankAddress: Yup.string().required("Please enter bank address."),
      beneficiaryName: Yup.string().required("Please enter beneficiary name."),
      bankAccountNum: Yup.string().required('Please enter bank account number.'),
      ifscCode: Yup.string().required('Please enter ifsc code.'),


    }),
    onSubmit: (values, { resetForm }) => {
      setDisable(true);
      try {

        let config = { headers: { "auth-token": Cookies.get('customertoken') } }

        axios.post(`${adminMainUrl}/api/customer-profile/bank-update`, values, config)
          .then(res => {
            if (res.status === 200) {

              resetForm();
              toast.success(res.data.msg);
              setDisable(false);
              dispatch(getCustomerProfileData(token))

            } else {
              toast.error(res.data.msg);
              setDisable(false);
            }
          }).catch(err => {
            console.log(err);
            if (err.response) {
              toast.error(err.response.data.msg);
            } else {
              toast.error("Internal server error.")
            }
            setDisable(false);
          });

      } catch (error) {
        console.log(error);
        toast.error(error.response.data.msg);
        setDisable(false);
      }
    }
  });

  useEffect(() => {
    if (CustomerProfileData) {
      formik.setValues({
        bankName: CustomerProfileData?.bankName ?? "",
        bankAddress: CustomerProfileData.bankAddress ?? "",
        beneficiaryName: CustomerProfileData.beneficiaryName ?? "",
        bankAccountNum: CustomerProfileData.bankAccountNum ?? "",
        ifscCode: CustomerProfileData.ifscCode ?? "",


      })
    }
  }, [CustomerProfileData])

  return (
    <>
      {/* <Toaster /> */}
      {
        // <div className="page-wrapper">
        //   <div className="content">
        <div id="section2 " className="section1 customer_main_detail_form">
          <form onSubmit={formik.handleSubmit} className='p-4'>
            <div className='form-heading-bg'>
              <span>Bank Details</span>

            </div>
            <FocusError formik={formik} />
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    for="basicpill-firstname-input"
                    className="form-label"
                  >
                    Bank Name<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='bankName'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.bankName}
                    maxLength={200}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.bankName && formik.errors.bankName ? (
                      <div className='text-danger small'>{formik.errors.bankName}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    for="basicpill-firstname-input"
                    className="form-label"
                  >
                    Bank Address<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='bankAddress'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.bankAddress}
                    maxLength={200}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.bankAddress && formik.errors.bankAddress ? (
                      <div className='text-danger small'>{formik.errors.bankAddress}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    for="basicpill-firstname-input"
                    className="form-label"
                  >
                    Beneficiary Name<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='beneficiaryName'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.beneficiaryName}
                    maxLength={30}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.beneficiaryName && formik.errors.beneficiaryName ? (
                      <div className='text-danger small'>{formik.errors.beneficiaryName}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    for="basicpill-firstname-input"
                    className="form-label"
                  >
                    Account No.<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='bankAccountNum'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.bankAccountNum}
                    maxLength={20}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.bankAccountNum && formik.errors.bankAccountNum ? (
                      <div className='text-danger small'>{formik.errors.bankAccountNum}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    for="basicpill-firstname-input"
                    className="form-label"
                  >
                    IFSC Code<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='ifscCode'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.ifscCode}
                    maxLength={15}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.ifscCode && formik.errors.ifscCode ? (
                      <div className='text-danger small'>{formik.errors.ifscCode}</div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>

            {!disbaledProfileEditing && <Paper className='h-100 d-flex flex-col justify-content-end w-100' square elevation={0} >
              <div className='button-container' style={{ marginTop: '20px' }}>
                <Button
                  className='btn-stepper  btn btn-primary'
                  variant="contained"
                  type='submit'
                  disabled={disable}
                >
                  {!disable ? "Update" : <i className="fas fa-spinner fa-spin" style={{ color: "#fff" }}></i>}
                </Button>
              </div>
            </Paper>}
          </form>
        </div >
        //   </div>
        // </div>
      }
    </>

  )
}

export default BankDetails